import React, { useState } from "react";
import { Link } from "react-router-dom";
import { blogPosts, categories } from "../../../data/blogData";
import "./Blog.css";

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");

  // Filter posts based on selected category
  const filteredPosts =
    selectedCategory === "All"
      ? blogPosts.slice(1) // Skip first post as it's featured
      : blogPosts.filter((post) => post.category === selectedCategory);

  return (
    <div className="blog-page">
      {/* Hero Section */}
      <section className="blog-hero">
        <div className="container">
          <h1>The GoalFlex Blog</h1>
          <p>
            Insights, tips, and stories from the world of recreational soccer.
            Stay updated on the latest trends, techniques, and community news.
          </p>
        </div>
      </section>

      {/* Featured Post */}
      <section className="featured-post-section">
        <div className="container">
          <div className="featured-post">
            <Link
              to={`/blog/${blogPosts[0].id}`}
              className="featured-post-link"
            >
              <div className="featured-image">
                <img src={blogPosts[0].image} alt={blogPosts[0].title} />
                <div className="featured-category">{blogPosts[0].category}</div>
              </div>
              <div className="featured-content">
                <h2>{blogPosts[0].title}</h2>
                <p>{blogPosts[0].excerpt}</p>
                <div className="post-meta">
                  <span className="author">By {blogPosts[0].author}</span>
                  <span className="date">{blogPosts[0].date}</span>
                  <span className="read-time">{blogPosts[0].readTime}</span>
                </div>
                <button className="read-more-btn">Read Full Article</button>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="blog-grid-section">
        <div className="container">
          {/* Category Filter */}
          <div className="category-filter">
            {categories.map((category) => (
              <button key={category} className="category-btn active">
                {category}
              </button>
            ))}
          </div>

          {/* Blog Grid */}
          <div className="blog-grid">
            {blogPosts.slice(1).map((post) => (
              <article key={post.id} className="blog-card">
                <Link to={`/blog/${post.id}`} className="blog-card-link">
                  <div className="blog-image">
                    <img src={post.image} alt={post.title} />
                    <div className="blog-category">{post.category}</div>
                  </div>
                  <div className="blog-content">
                    <h3>{post.title}</h3>
                    <p>{post.excerpt}</p>
                    <div className="blog-meta">
                      <div className="author-info">
                        <span className="author">By {post.author}</span>
                        <span className="date">{post.date}</span>
                      </div>
                      <span className="read-time">{post.readTime}</span>
                    </div>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="newsletter-section">
        <div className="container">
          <div className="newsletter-content">
            <h2>Stay in the Loop</h2>
            <p>
              Get the latest soccer tips, community stories, and GoalFlex
              updates delivered straight to your inbox.
            </p>
            <form className="newsletter-form">
              <input
                type="email"
                placeholder="Enter your email address"
                className="newsletter-input"
              />
              <button type="submit" className="newsletter-btn">
                Subscribe
              </button>
            </form>
            <p className="newsletter-disclaimer">
              We respect your privacy. Unsubscribe at any time.
            </p>
          </div>
        </div>
      </section>

      {/* Popular Topics */}
      <section className="popular-topics">
        <div className="container">
          <h2>Popular Topics</h2>
          <div className="topics-grid">
            <div className="topic-card">
              <div className="topic-icon">⚽</div>
              <h3>Skill Development</h3>
              <p>Tips and techniques to improve your game</p>
              <span className="post-count">12 articles</span>
            </div>
            <div className="topic-card">
              <div className="topic-icon">👥</div>
              <h3>Community Building</h3>
              <p>Creating lasting soccer friendships</p>
              <span className="post-count">8 articles</span>
            </div>
            <div className="topic-card">
              <div className="topic-icon">🏥</div>
              <h3>Health & Fitness</h3>
              <p>Stay injury-free and improve fitness</p>
              <span className="post-count">15 articles</span>
            </div>
            <div className="topic-card">
              <div className="topic-icon">📱</div>
              <h3>Tech & Innovation</h3>
              <p>How technology is changing soccer</p>
              <span className="post-count">6 articles</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
